module.exports = __webpack_public_path__ + "media/black_in_black_ac_dc_x_dang.89e02e6b.mp3";